import '.ek{font-size:1.125rem;}.ssr-plugin'
import '.el{line-height:1.75rem;}.ssr-plugin'
import '.i2{text-decoration:none;}.ssr-plugin'
import '.fp{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ek el"
    >
      {translations.privacySubtitle}{' '}
      <a className="i2 fp"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="i2 fp"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
